import { useEffect, useState } from 'react';
import { IconCircleXmark } from '@coverflex-tech/hypernova';
import { IFile } from '@coverflex-tech/hypernova-utils';
import classnames from 'classnames';
import css from './attachment-thumbnail.module.css';

interface IProps {
  attachment: IFile;
  selected?: boolean;
  onClick: () => void;
  onRemove?: () => void;
}

const AttachmentThumbnail = ({
  attachment,
  selected,
  onClick,
  onRemove,
}: IProps) => {
  const [previewError, setPreviewError] = useState(false);

  useEffect(() => {
    setPreviewError(false);
  }, [attachment]);

  const isImage = attachment.url || attachment.blob?.type.includes('image');
  const extension = attachment.name?.split('.').pop() ?? '';
  return (
    <div className={css.wrapper}>
      <div
        className={classnames(css.host, {
          [css.selected!]: selected,
        })}
        onClick={onClick}
      >
        {!isImage || previewError ? (
          <div className={css.preview}>{extension}</div>
        ) : (
          <img
            className={css.image}
            alt={attachment.name}
            src={attachment.url}
            onError={() => setPreviewError(true)}
          />
        )}
        {onRemove && (
          <button
            type="button"
            className={css.removeBtn}
            onClick={(evt) => {
              evt.stopPropagation();
              onRemove();
            }}
          >
            <IconCircleXmark />
          </button>
        )}
      </div>
    </div>
  );
};

export default AttachmentThumbnail;
